import * as React from 'react';

function SvgLayoutTextWindowReverse(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M13 6.5a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm-.5 2.5a.5.5 0 010 1h-5a.5.5 0 010-1h5z' />
			<path d='M14 0a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h12zM2 1a1 1 0 00-1 1v1h14V2a1 1 0 00-1-1H2zM1 4v10a1 1 0 001 1h2V4H1zm4 0v11h9a1 1 0 001-1V4H5z' />
		</svg>
	);
}

export default SvgLayoutTextWindowReverse;
